import React,{Component} from 'react';
import cookie from '../../helper/cookie'
import AddFrontfacerMutation from '../../mutations/AddFrontfacerMutation';
import Relay from 'react-relay';

export default class Front extends Component {
  constructor (props){
    super (props);

    var frontfacers = [];
    this.props.data.map((object, index) => {
      frontfacers.push({
        id:index+1,
        imageLink : object.imageLink,
        name : object.name,
        isEdit:false,
        pid: object.pid
      });
    });

    this.state={
      array: frontfacers,
      error:"",
    };

    this.addNew = this.addNew.bind(this);
    this.saveData=this.saveData.bind(this);
    this.removeRow=this.removeRow.bind(this);
    this.editData=this.editData.bind(this);
  }
  removeRow(i)
  {
    var tmpRows= this.state.array;
    tmpRows.splice(i,1);
    // Relay query to remove
    this.setState({array:tmpRows});
  }
  editData(i){
    var tmpRows= this.state.array;
    tmpRows[i].isEdit=true;
    this.setState({array:tmpRows});
  }
  saveData(text,i)
  {
    if(text!=="")
    {
      var frontFacers=this.state.array;
      var bool=false;
      for(var j=0;j<frontFacers.length;j++)
      {
          if(frontFacers[j].name==text && i!=j){
            bool=true;
            break;
          }
      }
      if(bool)
      {
        frontFacers[i].id=frontFacers[i].id;
        frontFacers[i].name=text;
        frontFacers[i].isEdit=true;
        this.setState({array:frontFacers,error:"Please enter unique frontfacer name"});
      }
      else {
        frontFacers[i].id=frontFacers[i].id;
        frontFacers[i].name=text;
        frontFacers[i].isEdit=false;

        Relay.Store.update(new AddFrontfacerMutation({
            name: frontFacers[i].name,
            picture: frontFacers[i].imageLink,
            agentId: cookie.get('userId')
          }), {
            onFailure: (t) => {
              console.log('onFailure of AddFrontFacer', t);
            },
            onSuccess: (t) => {
              console.log('onSuccess of AddFrontFacer', t);
            }
        });
        
        this.setState({array:frontFacers,error:""});
      }
    }
    else {
      this.setState({error:"Please fill all fields"});
    }
  }
  addNew(){
    var addNew = this.state.array;
    addNew.splice(0,0,{
                        id:addNew.length+1,
                        imageLink:"http://dndw32r4edmw5.cloudfront.net/avatar/Male.png",
                        name:"",
                        isEdit:true,
                      });
    this.setState({table_content:addNew});
  }

  render(){
    var st={
        vert: {
        verticalAlign:'bottom',
      },
      noborder:{
        border:'none',
      },
      background:{
        backgroundColor:"#fbfbfb",
        padding:5,
      },
      table:{
        tableLayout: 'fixed',
        wordWrap: 'break-word',
        borderRadius: '5px',
        backgroundColor: '#ffffff',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
      },
      scrollableDiv:{
        height:'368px',
        overflow:'auto',
      },
      noborderback:{
        border:'none',
        backgroundColor:"#fbfbfb",
      },
    };
  return(
    <div className="row">
      <div className="col-md-8" style={st.noborderback}>
        <p className="text-muted "><strong>FRONT FACERS</strong></p>
      </div>
      <div className="col-md-4" style={st.noborderback}>
        <p className="text-primary btn" onClick={this.addNew}><strong>ADD NEW</strong></p>
      </div>
      <table className="table table-hover" >
        <thead style={st.noborder}>
          <tr style={st.background}>
            <th className=" col-md-3 text-muted">Avatar</th>
            <th className=" col-md-7 text-center text-muted">Name</th>
          </tr>
        </thead>
      </table>
      <p className="text-danger">
        {this.state.error}
      </p>
      <div style={st.scrollableDiv} id="style-1">
        <table className="table table-hover" style={st.table}>
          <tbody>
            {this.state.array.map(function(con,i) {
              return (
                  <Row key={con.id} rowData={con} handleSave={this.saveData} rowref={i} handleRemove={this.removeRow} handleEdit={this.editData}/>
            );
          }.bind(this)
        )}
          </tbody>
        </table>
      </div>
      </div>
    );
  }
}
class Row extends Component {
  constructor(props) {
    super(props);
    this.editClicked=this.editClicked.bind(this);
    this.saveClicked=this.saveClicked.bind(this);
    this.removeClicked=this.removeClicked.bind(this);
  }
  removeClicked(){
    this.props.handleRemove(this.props.rowref);
  }
  editClicked()
  {
    this.props.handleEdit(this.props.rowref);
  }
  saveClicked()
  {
    this.props.handleSave(this.refs.input.value.trim(),this.props.rowref);
  }
  render()
  {
    var st={
      btn:{
        border:'none',
        outline:'none',
      },
      btnHover:{
        cursor:'pointer',
      },
    };
    if(this.props.rowData.isEdit) {
      return(
        <tr>
          <td className="col-md-3"><img src={this.props.rowData.imageLink} className=" img-circle img-responsive" alt="Cinque Terre" width="40" height="40" /></td>
          <td className="text-center col-md-7"><input type="text" className="form-control" ref="input" defaultValue={this.props.rowData.name} placeholder="Enter Name"/></td>
          <td className="col-md-2"><a style={st.btn} className="btn btn-link glyphicon glyphicon-floppy-disk" onClick={this.saveClicked}></a></td>
        </tr>
      );
    }
    else {
      return(
        <tr>
          <td className="col-md-3"><img src={this.props.rowData.imageLink} className=" img-circle img-responsive" alt="Cinque Terre" width="40" height="40" /></td>
          <td className="text-center col-md-7"><h4 className="text-muted">{this.props.rowData.name}</h4></td>
        </tr>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/AgentSettings/front_facer.js
 **/